import React, { forwardRef, Fragment, Ref } from 'react';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { ICommission, ISummarySale, IUser } from '../../@types';
import { Bonus } from './ExtraBonus';

interface ReportSheetProps {
  children: Array<{
    user: IUser;
    summary: ISummarySale;
  }>;
  fullSelectedUser: IUser | null;
  bonus?: Bonus[];
  users: any[];
  commissions: ICommission[];
  groupSale: number;
  sale: number;
  totalCommissionAmount: number;
  setReportMonth: React.Dispatch<React.SetStateAction<Date>>;
  totalProductCommission: number;
  totalOverrideCommission: number;
  totalSalesCommission: number;
  reportDate: Date;
  totalBonusCommission: number;
  otherCommission: number;
  className: string;
}

const ReportSheet = forwardRef(
  (
    {
      children,
      fullSelectedUser,
      bonus,
      users,
      commissions,
      groupSale,
      sale,
      totalCommissionAmount,
      setReportMonth,
      totalProductCommission,
      totalOverrideCommission,
      totalSalesCommission,
      reportDate,
      totalBonusCommission,
      otherCommission,
      ...props
    }: ReportSheetProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    console.log({bonus})
    // get role for fetched user
    const getRole = (role: string | undefined) => {
      if (!role) return;
      switch (role) {
        case 'srikandi_emas_vip':
          return 'Srikandi Platinum';
        case 'srikandi_emas':
          return 'Srikandi Emas';
        case 'srikandi':
          return 'Srikandi';
        case 'admin':
          return 'Admin';
        case 'user':
          return 'User';
        default:
          return role;
      }
    };
    // Function to map commission types to their string representation
    const getCommissionType = (c: string) => {
      switch (c) {
        case 'extra_group_commission':
          return 'Override Commission';
        case 'group_cash_bonus':
          return 'Group Cash Bonus';
        case 'cash_bonus':
          return 'Cash Bonus';
        case 'sales':
          return 'Order Sales Percentage';
        default:
          // Check if the type includes the word "product"
          return c.includes('product') ? 'Product Commission' : c || 'N/A';
      }
    };

    // Group the commissions by orderId and calculate the total amount for each commission type
    const grouped = commissions.reduce((acc, curr) => {
      const commissionType = getCommissionType(curr.type);

      switch (commissionType) {
        case 'Cash Bonus':
        case 'Group Cash Bonus':
          // Increment the total bonus commission amount
          totalBonusCommission += curr.amount;
          break;
        case 'Override Commission':
          // Increment the total override commission amount
          totalOverrideCommission += curr.amount;
          break;
        case 'Product Commission':
          // Increment the total product commission amount
          totalProductCommission += curr.amount;
          break;
        case 'Order Sales Percentage':
          // Increment the total sales commission amount
          totalSalesCommission += curr.amount;
          break;
        default:
          otherCommission += curr.amount;
          // Commission type is not recognized
          break;
      }

      // Increment the total commission amount
      // totalCommissionAmount += curr.amount;

      // Group the commissions by orderId
      acc[curr.orderId || 'rest'] = (acc[curr.orderId || 'rest'] || []).concat(curr);
      return acc;
    }, {} as { [orderId: string]: ICommission[] });
    totalCommissionAmount =
      sale * 0.05 +
      totalOverrideCommission +
      totalSalesCommission +
      totalBonusCommission +
      otherCommission;

    let validBonus = [] as Bonus[];
    bonus?.map((b) => {
      let getBonus = false
      if(b?.bonusDate !== undefined) {
        const dateString = b?.bonusDate;
        const dateObject = new Date(dateString + 'T00:00:00'); 
        // const bonusMonth = dateObject.getUTCMonth() + 1;
        const bonusMonth = parseFloat(dateString.slice(5,7));
        const bonusYear = dateObject.getUTCFullYear();
        const reportMonth = reportDate.getUTCMonth() + 1;
        const reportyear = reportDate.getUTCFullYear();
        if(bonusMonth === reportMonth && reportyear === bonusYear){
          getBonus = true;
        }
      }
      if(b?.amount !== undefined && getBonus){
        validBonus.push({
          amount: b.amount,
          bonusDate: b.bonusDate,
          email: b.email,
          titleBonus: b.titleBonus,
          created_at: b.created_at,
          created_by: b.created_by,
        })
        const bonusAmount = b?.amount || 0;
        totalCommissionAmount = parseFloat(bonusAmount.toString()) + parseFloat(totalCommissionAmount.toString())
      }  return b;
    })
    const formatAmount = (amount: any) => {
      const num = parseFloat(amount);
      if (isNaN(num)) {
        return 'Invalid amount';
      }
      return `RM ${num.toFixed(2)}`;
    };

    return (
      <div ref={ref} {...props}>
        <div style={{ width: '100%', display: 'flex' }}>
          <img src="/sk-logo.svg" width="150px" height="auto" />
        </div>
        <h2
          style={{
            textAlign: 'start',
            fontSize: '1rem',
            color: 'var(--accentColor)',
            marginBottom: '7mm',
            marginTop: '1mm',
          }}
        >
          Commission Slip
        </h2>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              flex: '1 30%',
              textAlign: 'start',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong style={{ textAlign: 'start', fontSize: '0.7rem' }}>
              {fullSelectedUser?.name}
            </strong>
            <span style={{ textAlign: 'start', fontSize: '0.5rem' }}>
              {fullSelectedUser?.email}
            </span>
            <span style={{ textAlign: 'start', fontSize: '0.5rem' }}>
              {getRole(fullSelectedUser?.role)}
            </span>
            <span style={{ textAlign: 'start', fontSize: '0.5rem' }}>
              SE: {users.find((e: any) => e.id === fullSelectedUser?.parent)?.name || 'N/A'}
            </span>
          </div>
          <div
            style={{
              flex: '1 40%',
              textAlign: 'start',
              display: 'flex',
              alignItems: 'baseline',
              flexWrap: 'wrap',
            }}
          >
            {/* {fullSelectedUser?.rankBonus?.amount && rankingUp ?
              (
                <>
                  <span style={{ flex: '1 0 47%', textAlign: 'end', fontSize: '0.5rem' }}>
                  Rank Bonus:{' '}
                  </span>
                  <strong
                    style={{
                      marginLeft: '10px',
                      flex: '1 0 47%',
                      textAlign: 'start',
                      fontSize: '0.5rem',
                    }}
                  >
                    RM {(fullSelectedUser?.rankBonus.amount as number).toFixed(2)}
                  </strong>
                </>
                
              ) : null
            } */}
            {fullSelectedUser?.role === 'srikandi_emas' ||'srikandi_emas_vip' ? (
              <>
                <span style={{ flex: '1 0 47%', textAlign: 'end', fontSize: '0.5rem' }}>
                  Group Sale:{' '}
                </span>
                <strong
                  style={{
                    marginLeft: '10px',
                    flex: '1 0 47%',
                    textAlign: 'start',
                    fontSize: '0.5rem',
                  }}
                >
                  RM {groupSale.toFixed(2)}
                </strong>
              </>
            ) : null}
            <span style={{ flex: '1 0 47%', textAlign: 'end', fontSize: '0.5rem' }}>
              Individual Sale:{' '}
            </span>
            <strong
              style={{
                marginLeft: '10px',
                flex: '1 0 47%',
                textAlign: 'start',
                fontSize: '0.5rem',
              }}
            >
              RM {sale.toFixed(2)}
            </strong>
            {fullSelectedUser?.role === 'srikandi_emas' || 'srikandi_emas_vip' ? (
              <>
                <span style={{ flex: '1 0 47%', textAlign: 'end', fontSize: '0.5rem' }}>
                  Target Achieved Srikandi:{' '}
                </span>
                {children.map((e: any, i: number) =>
                  i === 0 ? (
                    <span
                      key={i}
                      style={{
                        marginLeft: '10px',
                        flex: '1 0 47%',
                        textAlign: 'start',
                        fontSize: '0.5rem',
                      }}
                    >
                      {i + 1}. {e.user.name}
                    </span>
                  ) : (
                    <Fragment key={i}>
                      <span
                        style={{ flex: '1 0 47%', textAlign: 'end', fontSize: '0.5rem' }}
                      ></span>
                      <span
                        style={{
                          marginLeft: '10px',
                          flex: '1 0 47%',
                          textAlign: 'start',
                          fontSize: '0.5rem',
                        }}
                      >
                        {i + 1}. {e.user.name}
                      </span>
                    </Fragment>
                  ),
                )}
              </>
            ) : null}
          </div>
          <div
            style={{
              flex: '1 30%',
              alignItems: 'flex-end',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                width: '120px',
                marginTop: '-20mm',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                border: '2px solid var(--accentColor)',
                padding: '5px 10px',
              }}
            >
              <strong style={{ fontSize: '0.6rem' }}>Amount</strong>
              <span style={{ fontSize: '0.9rem', color: 'var(--accentColor)' }}>
                RM {totalCommissionAmount.toFixed(2)}
              </span>
            </div>
            <div
              style={{
                width: '120px',
                marginTop: '5mm',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <strong style={{ fontSize: '0.6rem' }}>Report Month</strong>
              <DatePicker
                onlyMonthPicker
                format="MMMM YYYY"
                onChange={(data) => {
                  // @ts-ignore
                  if (data) {
                    const date = (data as DateObject).toDate();
                    date.setHours(24);
                    setReportMonth(date);
                  }
                }}
                value={reportDate}
                minDate="2022/12/01"
                style={{
                  border: '1px solid var(--primaryColor)',
                  height: '20px',
                  width: '120px',
                  textAlign: 'center',
                  fontSize: '0.6rem',
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: '10mm' }}>
          <span style={{ textAlign: 'start', fontSize: '0.7rem' }}>Summary</span>
          <table>
            <thead>
              <tr style={{ borderStyle: 'hidden' }}>
                <th
                  style={{
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Total Commissions
                </th>
                <th
                  style={{
                    width: '15%',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                  Total Override Commission
                </td>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  RM {totalOverrideCommission.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                  Total Product Commission
                </td>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  RM {(sale * 0.05).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                  Total Sale Commission
                </td>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  RM {totalSalesCommission.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                  Total Bonus Commission
                </td>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  RM {totalBonusCommission.toFixed(2)}
                </td>
              </tr>
              {/* {fullSelectedUser?.rankBonus?.amount && rankingUp ? 
                (<tr>
                  <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                    Rank Bonus
                  </td>
                  <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                    RM  {(fullSelectedUser?.rankBonus.amount as number).toFixed(2)}
                  </td>
                </tr>) : null
              } */}
              {validBonus.length > 0 ? 
                  validBonus.map((bonus, index) => (
                      <tr key={index}>
                          <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                              {bonus.titleBonus}
                          </td>
                          <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {formatAmount(bonus.amount)}
                          </td>
                      </tr>
                  )) 
                  : null
              }

              <tr>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}>
                  Other Commissions
                </td>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  RM {otherCommission.toFixed(2)}
                </td>
              </tr>
              <tr style={{ borderBottom: 'hidden' }}>
                <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>Total</td>
                <td
                  style={{
                    fontWeight: 'bold',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'end',
                  }}
                >
                  RM {totalCommissionAmount.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: '10mm' }}>
          <span style={{ textAlign: 'start', fontSize: '0.7rem' }}>Itemised</span>
          <table>
            <thead>
              <tr style={{ borderStyle: 'hidden' }}>
                <th
                  style={{
                    width: '15%',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Order ID
                </th>
                <th
                  style={{
                    width: '35%',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Title
                </th>
                <th
                  style={{
                    width: '15%',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  SKU
                </th>
                <th
                  style={{
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Type
                </th>
                <th
                  style={{
                    width: '10%',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'center',
                    color: 'white',
                    backgroundColor: 'var(--accentColor)',
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.values(grouped).map((e: any, idx: number) => {
                const productCommissiom = e.reduce((acc: any, curr: any) => {
                  if (curr.type !== 'sales') {
                    acc += curr.amount;
                  }
                  return acc;
                }, 0);
                return (
                  <Fragment key={idx}>
                    {e.map((a: any, i: number, v: any[]) => {
                      if (i === 0) {
                        // for sales commission percentage
                        return (
                          <tr key={i}>
                            <td
                              rowSpan={v.length}
                              style={{ fontSize: '0.6rem', padding: '0', textAlign: 'start' }}
                            >
                              {a.orderName || a.orderId}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.title}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.sku}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {getCommissionType(a.type)}
                            </td>
                            <td
                              // rowSpan={1}
                              style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}
                            >
                              RM {a.amount.toFixed(2)}
                            </td>
                          </tr>
                        );
                      } else if (i === 1) {
                        // for product commission
                        return (
                          <tr key={i}>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.title}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.sku}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {getCommissionType(a.type)}
                            </td>
                            <td
                              rowSpan={v.length - 1}
                              style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}
                            >
                              RM {parseFloat(a.amount).toFixed(2) ? parseFloat(a.amount).toFixed(2) : a.amount.toFixed(2)}
                            </td>
                          </tr>
                        );
                      } else {
                        // for product commission
                        return (
                          <tr key={i}>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.title}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {a.sku}
                            </td>
                            <td style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                              {getCommissionType(a.type)}
                            </td>
                          </tr>
                        );
                      }
                    })}
                  </Fragment>
                );
              })}
              <tr style={{ borderBottom: 'hidden' }}>
                <td colSpan={4} style={{ fontSize: '0.6rem', padding: '0', textAlign: 'end' }}>
                  Total
                </td>
                <td
                  style={{
                    fontWeight: 'bold',
                    fontSize: '0.6rem',
                    padding: '0',
                    textAlign: 'end',
                  }}
                >
                  RM {totalCommissionAmount.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  },
);

export default ReportSheet;
